/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable no-unused-expressions */
import { getContactList, updateStatusContact } from 'APIs/contactList'
import { hideOverlay, showModalMessage, showOverlay } from 'Modules/store/actions'
import { call, put, takeLatest, select } from 'redux-saga/effects'
import { REQUEST, SUCCESS } from 'Stores'
import { formatMessage } from 'Utils/formatMessage'
import { makeSelectContact } from './selectors'
import { GET_CONTACT, UPDATE__STATUS_CONTACT } from './constants'

export function* getContactSaga({ payload }) {
  try {
    yield put(showOverlay())
    const data = yield call(getContactList, payload)
    yield put({
      type: SUCCESS(GET_CONTACT),
      payload: {
        contact: data.result
      }
    })
    yield put(hideOverlay())
  } catch (error) {
    yield put(hideOverlay())
    yield put(showModalMessage({ message: formatMessage(error) }))
  }
}

export function* updateStatusContactSaga({ payload }) {
  try {
    yield put(showOverlay())
    const data = yield call(updateStatusContact, payload)
    const { getContact } = yield select(makeSelectContact())
    const rows = getContact?.rows?.map((item) => {
      if (item?.id === data?.result?.id) {
        return {
          content: data?.result?.content,
          created_at: data?.result?.created_at,
          email: data?.result?.email,
          id: data?.result?.id,
          status: data?.result?.status,
          user_id: data?.result?.user_id
        }
      }
      return item
    })

    yield put({
      type: SUCCESS(GET_CONTACT),
      payload: {
        contact: {
          count: getContact?.count,
          rows
        }
      }
    })
    yield put(showModalMessage({ message: formatMessage('SUPPORT_CONTACT_SUCCESS'), type: 'success' }))
    yield put(hideOverlay())
  } catch (error) {
    yield put(hideOverlay())
    yield put(showModalMessage({ message: formatMessage(error) }))
  }
}

export default function* contactSaga() {
  yield takeLatest(REQUEST(GET_CONTACT), getContactSaga)
  yield takeLatest(REQUEST(UPDATE__STATUS_CONTACT), updateStatusContactSaga)
}
